import { DefaultSpinner } from "components/loading/DefaultSpinner";

export const ToolSpinner = () => {
  return (
    <div className="tool-spinner-container">
      <DefaultSpinner spinnerSize={23} />
    </div>
  );
};
